import React from 'react';
import { Link } from 'react-router-dom';

const HorseCard = React.memo(({ _id, horseInfo = {}, saleInfo = {}, status, fromTab }) => {
  const { name, images = [], breed, age } = horseInfo;
  const price = saleInfo?.buyNowPrice;

  const priceLabel =
    status === 'Sold' ? 'Sold For' :
    status === 'Active Bid' ? 'Current Bid' :
    status === 'Bought' ? 'Bought For' :
    'Asking Price';

  return (
    <div className="bg-white rounded shadow border-2 border-sage">
      <div className="mb-3">
        {images.length > 0 ? (
          <img
            src={images[0]}
            alt={name}
            className="w-full h-full object-cover rounded"
          />
        ) : (
          <div className="w-full h-48 bg-gray-200 flex items-center justify-center rounded text-gray-500">
            No image available
          </div>
        )}
      </div>

      <div className="p-3">
        <h2 className="text-2xl font-semibold mb-2 font-montserrat">{name}</h2>
        <div className="text-md text-text space-y-1 mb-3 font-montserrat">
          <p><span className="font-medium">Breed:</span> {breed?.name || 'N/A'}</p>
          <p><span className="font-medium">Age:</span> {age || 'N/A'}</p>
          <p><span className="font-medium">{priceLabel}:</span> {price ? `$${price.toLocaleString()}` : 'N/A'}</p>
        </div>

        <Link
          to={`/horses/${_id}`}
          state={{ fromTab }}
          className="inline-block text-primary text-sm font-bold font-montserrat"
        >
          View Profile →
        </Link>
      </div>
    </div>
  );
});

export default HorseCard;